module.exports = __webpack_public_path__ + "f4bb7784a3c36448156d9e813815dc01.svg";